import Vue from 'vue';

//#region inputs
import UiInput from 'ui-input';
import UiCheckbox from 'ui-checkbox';
import UiGroupValidator from 'ui-group-validator';
import UiTags from 'ui-tags';
import UiTextEditor from 'ui-text-editor';
import UiTextarea from 'ui-textarea';
import UiDropdown from 'ui-dropdown';
import UiSelect from 'ui-select';
import UiDatePicker from 'ui-date-picker';
import UiToggleSwitcher from 'ui-toggle-switcher';
//#endregion
import UiButton from 'ui-button';
import CropImage from 'crop-image';
import DropdownMenu from 'dropdown-menu';
import ListView from 'list-view';
import ModalWindow from 'modal-window';
import UiLoading from 'ui-loading';
import UiProgressBar from 'ui-progress-bar';
import UiTable from 'ui-table';
import UiTabs from 'ui-tabs';
import UiToolbar from 'ui-toolbar';
import UiTree from 'ui-tree';
import UiScroll from 'ui-scroll';
import UiChart from 'ui-chart';
import UiEventCalendar from 'ui-event-calendar';

import UiPopupWindow from 'ui-popup-window';

import UiBoxMenu from 'ui-box-menu';

import { ListViewItem }  from 'list-view'
export {
  ListViewItem
}

var components = [
  UiButton,
  UiCheckbox,
  UiGroupValidator,
  UiTags,
  UiTextEditor,
  UiTextarea,
  UiInput,
  UiSelect,
  UiDatePicker,
  UiToggleSwitcher,
  CropImage,
  DropdownMenu,
  ListView,
  ModalWindow,
  UiLoading,
  UiProgressBar,
  UiTable,
  UiTabs,
  UiToolbar,
  UiTree,
  UiDropdown,
  UiBoxMenu,
  UiScroll,
  UiPopupWindow,
  UiChart,
  UiEventCalendar
]

function registerComponents(listComponents) {
  listComponents.forEach(function(component) {
    if(Array.isArray(component)) {
      registerComponents(component)
    } else if(component.extendOptions) {
      Vue.component(component.extendOptions.name, component);
    } else {
      console.warn('Не найдены расширенные свойства компонента.')
    }
  })
}

registerComponents(components);

export default components


//////////////////
// WEBPACK FOOTER
// ./~/ui-components/index.js
// module id = 300
// module chunks = 0